import React, {useEffect, useState}  from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {     
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    Label,
    Button,
    Badge,
    Form,
    Input,
    InputGroup, Container,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
 } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import { Link, useHistory, useParams, useLocation } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import * as url from "../../helpers/url_helper"

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";


    const PAs = () => {
        const {type} = useParams();
        const location = useLocation();

        const history = useHistory()
        const [paList, setPaList] = useState([])
        const [isloading, setIsloading] = useState(false)

        useEffect(() => {
            const obj = JSON.parse(localStorage.getItem("authMildUser"));
            const EmployeeNo = obj.uid;
            const CompanyID = obj.activeCompany;
            let urlx = " url string";
            (location.pathname == '/performance-appraisals') ? 
            ( urlx = `${url.MPAS}?$filter=EmployeeNo eq '${EmployeeNo}'&$expand=mpaLines,mpaLines2,mpaLines4&company='${CompanyID}'`) : 
             (urlx = `${url.FPAS}?$filter=EmployeeNo eq '${EmployeeNo}'&$expand=paLines1,paLines2,paLines3,paLines4,paLines5,paLines6&company='${CompanyID}'`)
            setIsloading(true) 
            axios.get(urlx, HRConfig).then((r)=>{
              console.log(r)
              setPaList(r.data.value);
              //console.log(r)
              setIsloading(false)
            }).catch((e)=>{
              console.log(e)
              setIsloading(false)
            })
          }, []);
        

        const { SearchBar } = Search;
        const columns = [
          {
            dataField: 'No',
            text: 'No',
            sort: true
        }, 
        {
            dataField: 'PostingDate',
            text: 'Date',
            sort: true
        }, 
        {
            dataField: 'Phase',
            text: 'Phase',
            sort: true,
             // eslint-disable-next-line react/display-name
             formatter: (cellContent, row) => (
              <>{row.Phase}</>
            ),
          }, 
        
        {
            dataField: 'appraiser',
            text: 'Appraiseer',
            sort: true,
             // eslint-disable-next-line react/display-name
             formatter: (cellContent, row) => (
              <>
              <p className="text-muted mb-0">{row.Appraiser}</p>
                <h5 className="font-size-14 mb-1">
                  <Link to="#" className="text-dark">
                  {row.AppraiserNames}
                  </Link>
                </h5>
                <p className="text-muted mb-0">{row.AppraiserJobTitle}</p>
              </>
            ),
          }, 

        
          {
            dataField: 'performance1',
            text: 'Overall Performance',
            sort: true,
             // eslint-disable-next-line react/display-name
             formatter: (cellContent, row) => (
              <>
                <p className="text-muted mb-0"><strong>{row.OverallMidyearAssessment.toFixed(2)}</strong></p>
                
              </>
            ),
          }, 
        {
          dataField: 'Status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];
  
        const defaultSorted = [{
          dataField: 'No',
          order: 'desc'
        }];
  
        function linesFormatter(cellContent, row){
          return(
            <strong></strong>
          )
        }
        function noFormatter(cellContent, row){
          return(
            <strong>{cellContent}</strong>
          )
        }
  
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
              type="button"
              color="info"
              className="btn-sm btn-rounded"
              onClick={()=>{ history.push(`/staff-performance-appraisal/${row.SystemId}`)}}
            >
              Details
            </Button>
          </>
          )
        }
        function statusFormatter(cellContent, row) {
          if (row.Status == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if (row.Status == "Approved"){
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        return (
            <>
          <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...' >
                <div className="page-content">
                    <MetaTags>
                    <title>Performance Appraisals | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem={(location.pathname == '/performance-appraisals')?`Mid term appraisals`:`Full term appraisals`} />
                        
                       {/* <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <CardTitle className="h5 mb-4">Filter</CardTitle>
                              <Form className="row gy-2 gx-3 align-items-center" >
                                <Row>
                                <Col lg={5}>
                                <div className="col-sm-auto">
                                    <Flatpickr
                                      className="form-control d-block filterDate"
                                      placeholder="dd M,yyyy"
                                      options={{
                                        mode: "range",
                                        dateFormat: "Y-m-d"
                                      }}
                                    />
                                </div>
                                </Col>
                                <Col lg={5}>
                                <div className="col-sm-auto">
                                  <label className="visually-hidden" htmlFor="autoSizingSelect">By Status</label>
                                  <select defaultValue="0" className="form-select filterStatus">
                                    <option value=""> Select Status </option>
                                    <option value="">All</option>
                                    <option value="Open">Open</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Pending Approval">Pending Approval</option>
                                  </select>
                                </div>
                                </Col><Col lg={2}>
                                <div className="col-sm-auto">
                                  <button type="submit" className="btn btn-primary w-md">Filter</button>
                                </div>
                                </Col>
                                </Row>
                              </Form>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row> */} 
                      <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle></CardTitle>
                  <CardSubtitle className="mb-3">
                    
                  </CardSubtitle>

                 {paList && (paList.length > 0) && (
                  <ToolkitProvider
                      keyField="No"
                      data={ paList }
                      columns={ columns }
                      search
                    >
                      { toolkitProps => (
                          <React.Fragment>
                          <Row className='mb-5'>
                              <Col lg={8} className='mb-2'>
                                <div  className="rounded bg-light d-grid gap-2">
                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                </div>
                              </Col>
                        
                              <Col lg={4}> 
                           
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table">
                            
                                <BootstrapTable 
                                  keyField='No' 
                                  data={ paList } 
                                  columns={ columns } 
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  noDataIndication="No Records" 
                                  defaultSorted={ defaultSorted }
                                  classes={ "table align-middle table-nowrap table-check" }
                                    {...toolkitProps.baseProps}
                                  />
                             </div>
                             </Col>
                             </Row>
                             </React.Fragment>
                            
                      )
                    }
                  </ToolkitProvider>
                  

                  )}
                  {paList && (paList.length < 1) && (
                    <div className="text-center">
                      <div className="mb-4">
                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                      </div>
                      <div>
                      <h5>No Performance Appraisal Found</h5>
                      <p className="text-muted">
                              
                      </p>
                      </div>
                  </div>

                  )}
                  
                </CardBody>
              </Card>
            </Col>
          </Row>


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PAs;